import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {};

const AssignmentPageLayout = (props: Props) => {
  return (
    <><Outlet /></>
  );
};

export default AssignmentPageLayout;